"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeKeys = function (obj, keysToOmit) {
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
        if (keysToOmit.indexOf(key) === -1) {
            newObj[key] = obj[key];
        }
    });
    return newObj;
};
